import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 32px;
  height: 100%;
  width: 100%;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const Title = styled.p`
  ${typographyV2.titleLg}
  text-align: left;
`;
